import { createAsyncThunk } from "@reduxjs/toolkit"
import { asyncThunkWrapper } from "../thunkHandler"
import { BASEURI, headers } from "../../utils/helper"


// --------------- Handle create appointments ---------------
export const handleCreateAppointment = createAsyncThunk(
  "create",
  async (data, thunkAPI) => {
    const { memberId, appointmentDate, startTime, endTime, notes, timeZone } = data;

    return asyncThunkWrapper(
      {
        data: {
          appointmentDate,
          startTime,
          endTime,
          notes, timeZone, memberId
        },
        method: "POST",
        headers: headers(),
        url: `${BASEURI}/specialist/appointments/create`,
      },
      thunkAPI
    );
  }
);

export const handleRescheduleAppointment = createAsyncThunk(
  "appointment/reschedule",
  async (data, thunkAPI) => {



    const {
      appointmentId,
      lockId,
      timezone,
    } = data;
    return asyncThunkWrapper(
      {
        data: {
          lockId,
          timezone,
        },

        method: "PATCH",

        headers: headers(),

        url: `${BASEURI}/member/appointments/reschedule/${appointmentId}`,
      },
      thunkAPI
    );
  }
);


// --------------- Handle get all appointments ---------------
export const handleRetrieveAllAppointments = createAsyncThunk(
  "retrieveAll",
  async (data, thunkAPI) => {
    const params = {
      type: data?.type || null,
      limit: data?.limit || 10,
      date: data?.date || null,
      search: data?.search || "",
      status: data?.status || null,
      endDate: data?.endDate || null,
      startDate: data?.startDate || null,
      currentPage: data?.currentPage || null,
    }

    return asyncThunkWrapper(
      {
        params,
        method: "GET",
        headers: headers(),
        url: `${BASEURI}/specialist/appointments/retrieve-all`,
      },
      thunkAPI,
      { toast: false }
    )
  }
)

// --------------- Handle accept appointment ---------------
export const handleAcceptAppointments = createAsyncThunk(
  "update",
  async (id, thunkAPI) => {

    return asyncThunkWrapper(
      {
        method: "PUT",
        headers: headers(),
        url: `${BASEURI}/specialist/appointments/accept/${id}`,
      },
      thunkAPI,
    )
  }
)

// --------------- Handle reject appointment ---------------
export const handleRejectAppointments = createAsyncThunk(
  "update",
  async (data, thunkAPI) => {

    return asyncThunkWrapper(
      {
        method: "PUT",
        headers: headers(),
        data: data?.formData || {},
        url: `${BASEURI}/specialist/appointments/reject/${data?.id}`,
      },
      thunkAPI,
    )
  }
)

// --------------- Specialist mark member as No Show ---------------
export const handleSpecialistMarkNoShow = createAsyncThunk(
  "update",
  async (id, thunkAPI) => {
    return asyncThunkWrapper(
      {
        method: "PUT",
        headers: headers(),
        url: `${BASEURI}/specialist/appointments/no-show-member/${id}`,
      },
      thunkAPI,
      { successToast: true, successMsg: "Marked as No Show successfully!" }
    )
  }
)

// --------------- Specialist cancel appointment ---------------
export const handleSpecialistCancelAppointment = createAsyncThunk(
  "cancel",
  async (data, thunkAPI) => {
    return asyncThunkWrapper(
      {
        data: data?.formData,
        method: "PUT",
        headers: headers(),
        url: `${BASEURI}/specialist/appointments/cancel/${data?.id}`,
      },
      thunkAPI,
    )
  }
)